export const apiRoute = {
    webform: {
        get: '/webform',
        getLink: '/webform/iframe',
        preview: '/webform/preview',
        update: '/webform',
        hasWebFormSetup: '/has-web-integration-setup'
    }
};
